/*
 * Aléo Studio size guide panel. Renders the Size tab (conversion table +
 * this product's own Size & Fit text) and, when the product's title
 * matches a garment keyword (window.ALEO_SIZE_GUIDE_TITLE_MAP in
 * assets/aleo-size-guide-data.js), the Garment Measurements tab --
 * client-side, the first time the panel is opened, then just
 * shows/hides the already-built content on later opens. No title match
 * means no Garment measurements tab at all (hidden, not guessed).
 */
(function () {
  var unitState = 'cm'; // shared across every open panel instance

  function formatValue(cm) {
    if (unitState === 'cm') return cm.toFixed(1);
    return (cm / 2.54).toFixed(1);
  }

  function buildSizeTabHtml(fitContentHtml) {
    var conv = window.ALEO_SIZE_CONVERSION || { aleo: [], womens: [] };
    var html = '';
    html += '<div class="aleo-size-guide__table-scroll aleo-size-guide__table-scroll--conversion"><table class="aleo-size-guide__table aleo-size-guide__table--conversion">';
    html += '<thead><tr><th scope="col">Aléo Studio</th>';
    conv.aleo.forEach(function (s) { html += '<th scope="col">' + s + '</th>'; });
    html += '</tr></thead><tbody>';
    html += '<tr><th scope="row">Men’s equivalent</th>';
    conv.aleo.forEach(function (s) { html += '<td>' + s + '</td>'; });
    html += '</tr>';
    html += '<tr><th scope="row">Women’s equivalent</th>';
    conv.womens.forEach(function (s) { html += '<td>' + s + '</td>'; });
    html += '</tr>';
    html += '</tbody></table></div>';
    html += '<p class="aleo-size-guide__note">Generally, male sizing is recommended to choose true size. Female sizing is recommended to size down.</p>';
    if (fitContentHtml) {
      html += '<div class="aleo-size-guide__fit rte">' + fitContentHtml + '</div>';
    }
    return html;
  }

  function unitSuffix() {
    return unitState === 'cm' ? 'CM' : 'IN';
  }

  function buildMeasurementsTabHtml(data, diagramMarkup) {
    var html = '';
    html += '<div class="aleo-size-guide__unit-toggle" role="group" aria-label="Units">';
    html += '<button type="button" class="aleo-size-guide__unit-btn' + (unitState === 'cm' ? ' is-active' : '') + '" data-aleo-size-guide-unit="cm">CM</button>';
    html += '<button type="button" class="aleo-size-guide__unit-btn' + (unitState === 'in' ? ' is-active' : '') + '" data-aleo-size-guide-unit="in">INCHES</button>';
    html += '</div>';

    if (diagramMarkup) {
      html += '<div class="aleo-size-guide__diagram" aria-label="Garment measurement diagram">' + diagramMarkup + '</div>';
    }

    // Graded table: one row per size (sizes[i] <-> rows_cm[i]), one
    // column per A/B/C/D measurement. Each column header shows the
    // diagram letter + name (matching the lettering on the garment's own
    // sketch) plus the current unit, e.g. "A · Chest (CM)" --
    // refreshMeasurementValues below swaps just the unit suffix on
    // toggle, not the whole label. No row (Medium included) is bolded or
    // otherwise highlighted -- every size reads the same.
    html += '<div class="aleo-size-guide__table-scroll"><table class="aleo-size-guide__table aleo-size-guide__table--measurements" data-aleo-size-guide-measurements-table>';
    html += '<thead><tr><th scope="col">Size</th>';
    data.columns.forEach(function (col) {
      var label = col.label + ' · ' + col.name;
      html += '<th scope="col" data-aleo-size-guide-header-label="' + label + '">' + label + ' (' + unitSuffix() + ')</th>';
    });
    html += '</tr></thead><tbody>';
    data.sizes.forEach(function (size, i) {
      html += '<tr><th scope="row">' + size + '</th>';
      data.rows_cm[i].forEach(function (cm) {
        html += '<td data-aleo-size-guide-cm="' + cm + '">' + formatValue(cm) + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    html += '<p class="aleo-size-guide__footnote">All measurements are taken with the garment laying flat.</p>';
    return html;
  }

  function refreshMeasurementValues(root) {
    var cells = root.querySelectorAll('[data-aleo-size-guide-cm]');
    cells.forEach(function (cell) {
      cell.textContent = formatValue(Number(cell.getAttribute('data-aleo-size-guide-cm')));
    });
    var headers = root.querySelectorAll('[data-aleo-size-guide-header-label]');
    headers.forEach(function (th) {
      th.textContent = th.getAttribute('data-aleo-size-guide-header-label') + ' (' + unitSuffix() + ')';
    });
    var buttons = root.querySelectorAll('[data-aleo-size-guide-unit]');
    buttons.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-aleo-size-guide-unit') === unitState);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('aleo-size-guide-drawer');
    if (!drawer) return;

    var sizePanel = drawer.querySelector('[data-aleo-size-guide-panel="size"]');
    var measurementsPanel = drawer.querySelector('[data-aleo-size-guide-panel="measurements"]');
    var tabs = Array.prototype.slice.call(drawer.querySelectorAll('.aleo-size-guide__tab'));
    var measurementsTabBtn = drawer.querySelector('[data-aleo-size-guide-tab="measurements"]');

    var fitEl = drawer.querySelector('[data-aleo-size-guide-fit]');
    var fitContentHtml = fitEl ? fitEl.innerHTML.trim() : '';

    var diagramMarkup = {};
    Array.prototype.slice.call(drawer.querySelectorAll('template[data-aleo-size-guide-diagram]')).forEach(function (tpl) {
      diagramMarkup[tpl.dataset.aleoSizeGuideDiagram] = tpl.innerHTML;
    });

    var sizeTabRendered = false;
    var renderedMeasurementsType = null;

    function renderForType(sizeGuideType) {
      if (!sizeTabRendered) {
        sizeTabRendered = true;
        sizePanel.innerHTML = buildSizeTabHtml(fitContentHtml);
      }

      var data = sizeGuideType && window.ALEO_SIZE_GUIDE ? window.ALEO_SIZE_GUIDE[sizeGuideType] : null;

      if (!data) {
        measurementsTabBtn.hidden = true;
        return;
      }

      measurementsTabBtn.hidden = false;
      if (renderedMeasurementsType !== sizeGuideType) {
        renderedMeasurementsType = sizeGuideType;
        measurementsPanel.innerHTML = buildMeasurementsTabHtml(data, diagramMarkup[data.diagram]);
      }
    }

    function setActiveTab(tabName) {
      // A hidden (no garment match) measurements tab can't become active.
      if (tabName === 'measurements' && measurementsTabBtn.hidden) tabName = 'size';
      tabs.forEach(function (btn) {
        var isActive = btn.dataset.aleoSizeGuideTab === tabName;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      sizePanel.hidden = tabName !== 'size';
      measurementsPanel.hidden = tabName !== 'measurements';
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveTab(btn.dataset.aleoSizeGuideTab);
      });
    });

    drawer.addEventListener('click', function (evt) {
      var unitBtn = evt.target.closest('[data-aleo-size-guide-unit]');
      if (!unitBtn) return;
      unitState = unitBtn.getAttribute('data-aleo-size-guide-unit');
      refreshMeasurementValues(drawer);
    });

    document.addEventListener('click', function (evt) {
      var trigger = evt.target.closest('[data-aleo-size-guide-trigger]');
      if (!trigger) return;
      evt.preventDefault();
      var sizeGuideType = window.aleoResolveSizeGuideType ? window.aleoResolveSizeGuideType(trigger.dataset.productTitle) : null;
      renderForType(sizeGuideType);
      setActiveTab('size');
      drawer.open(trigger);
    });
  });
})();
